<template>
  <NodePage v-if="node" v-bind="node" :class="{ 'cursor-wait': pending }">
    <template #paragraphs-before>
      <div
        ref="scrollToEl"
        class="grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-20 lg:gap-30 mt-20 md:mt-40 lg:mt-60 scroll-mt-40"
        :class="{ 'opacity-25 pointer-events-none': pending }"
      >
        <ArticleTeaser
          v-for="article in articles"
          :key="article.id"
          v-bind="article"
        />
      </div>
      <div
        v-if="totalPages > 1"
        class="bg-gray-50 md:sticky md:bottom-0 mt-20 md:py-25 md:px-10 md:-mx-10"
      >
        <Pagination
          :page="page"
          :total-pages="totalPages"
          @change-page="onChangePage"
        />
      </div>
    </template>
  </NodePage>
</template>

<script lang="ts" setup>
import type { AllPressReleasesQueryVariables } from '#graphql-operations'
import Pagination from '~/components/Pagination/index.vue'

definePageMeta({
  name: 'press-releases',
  drupalRoute: true,
  drupalFrontendRoute: true,
  path: '/politik-und-medien/medien/medienmitteilungen',
  languageMapping: {
    fr: '/politique-et-medias/medias/communiques-de-presse',
    it: '/politica-e-media/media/comunicati-stampa',
  },
})

const route = useRoute()
const { entity: node } = await useDrupalRouteQuery('nodePage')

// The amount of items per page.
const perPage = 12

// The current page for the pagination.
const page = computed<number>(() => {
  if (typeof route.query.page === 'string') {
    return parseInt(route.query.page)
  }

  return 0
})

const variables = computed<AllPressReleasesQueryVariables>(() => {
  return {
    offset: page.value * perPage,
    perPage,
  }
})

// Load the articles.
const { data, pending } = await useAsyncGraphqlQuery(
  'allPressReleases',
  variables,
  {
    transform: (v) => v.data.entityQuery,
    graphqlCaching: {
      client: true,
    },
  },
)

// The articles.
const articles = computed(() => {
  return (data.value?.items || []).filter(
    (v) => v.__typename === 'NodePressRelease',
  )
})

// The amount of total pages.
const totalPages = computed<number>(() => {
  return Math.ceil((data.value?.total || 0) / perPage)
})

const scrollToEl = ref<HTMLDivElement | null>(null)
const { onChangePage } = usePaginationChange(scrollToEl)

useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PagePharmasuissePressReleases',
}
</script>
